// extracted by mini-css-extract-plugin
module.exports = {"jobsSectionContainer":"JobsSection_jobsSectionContainer__ZxuUv","jobsSectionTitle":"JobsSection_jobsSectionTitle__Zp2nP","jobsGrid":"JobsSection_jobsGrid__4qrhZ"};